/**
 * Platform detection utilities for Tauri desktop vs web browser.
 */

/**
 * Check if we're running inside a Tauri desktop app.
 * Uses the `__TAURI_INTERNALS__` global that Tauri injects into the webview.
 */
export function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

/**
 * Get the current platform: "macos", "windows", "linux", or "web".
 */
export function getPlatform(): "macos" | "windows" | "linux" | "web" {
  if (!isTauri()) return "web";

  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("macintosh") || ua.includes("mac os")) return "macos";
  if (ua.includes("windows")) return "windows";
  return "linux";
}

/**
 * Check if platform is macOS (for traffic light padding etc.)
 */
export function isMacOS(): boolean {
  return getPlatform() === "macos";
}
